<div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    *ngIf="router.url.includes('teacher-classroom') || router.url.includes('classroom-details')"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="true"
    [zIndex]="1003"
  >
  </ngx-spinner>

  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    *ngIf="router.url.includes('teacher-only-assistant')"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="true"
    [zIndex]="1003"
  >
  </ngx-spinner>

  <div class="text-right mb-3" *ngIf="isExpand === true">
    <button class="btn-close" (click)="closeDialog()">
      <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
    </button>
  </div>

  <div class="row">
    <div class="{{ isCardView ? 'col-12 col-md-12' : 'col-md-8' }}">
      <ng-container *ngTemplateOutlet="contentTemplate; context: { data: 'send' }"></ng-container>
    </div>
    <div class="col-md-4 previous-questions-content" *ngIf="!isCardView">
      <div class="label-content quicksand-bold-label pl-2 pr-2 text-black">Previously Asked Questions</div>

      <div class="questions-content mt-3">
        <div class="form-group has-search">
          <img
            src="/assets/icons/search.svg"
            alt="search-icon"
            class="mt-1 form-control-feedback"
            height="17"
            width="17"
          />
          <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchText" />
        </div>

        <div class="questions-loop">
          <div
            class="mt-3 main-questions-view-content quicksand-bold-label d-flex cursor-pointer"
            *ngFor="let question of aiAssistantRecords | search : searchText"
          >
            <div (click)="showAssistantRecord($event, question)">
              <nb-icon icon="arrow-ios-back-outline" class="see-question-icon"></nb-icon>
            </div>
            <div class="quicksand-bold-label" (click)="showAssistantRecord($event, question)">
              {{ question?.message }}
            </div>

            <div
              (click)="openDeleteModal(question?.id)"
              class="delete ml-auto"
              *ngIf="localStorageUser?.user?.role_id === 19"
            >
              <img
                src="/assets/icons/delete.svg"
                alt="delete-icon"
                class="cursor-pointer"
                height="20"
                width="20"
                loading="lazy"
              />
            </div>
          </div>

          <div
            class="load-more-content text-center mt-2"
            *ngIf="currentPage !== pageTotal && aiAssistantRecords.length > 0"
          >
            <label class="quicksand-bold-label load-more-content-label cursor-pointer" (click)="getRecordsPerPage()"
              ><nb-icon icon="sync-outline"></nb-icon> Load More...</label
            >
          </div>

          <div *ngIf="aiAssistantRecords === undefined || aiAssistantRecords?.length === 0" class="text-center">
            <img src="/assets/images/respond-edu.svg" height="150" width="150" alt="no-data-found" loading="lazy" />
            <h6 class="quicksand-bold-label">No Records Found!</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- assitant chat bot card template -->
<ng-template #contentTemplate let-data="data">
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="input-field-content">
      <div class="input-field-content-header-label">Teacher’s Assistant</div>

      <div class="quicksand-bold-label text-white mt-1 ask-anything-label">
        You can consult with your AI assistant on any and all school-related issues you come across in your daily
        operations.
        <br />
        <label class="quicksand-bold-label text-white" style="font-size: 12px">
          For eg. "What do I do if a student shows up to school with lice?"
        </label>
      </div>
    </div>
    <div
      class="main-question-answer-content {{ isExpand ? 'expanded' : '' }}"
      [ngClass]="{
        'set-height': currentUrl.includes('teacher-only-assistant')
      }"
    >
      <div class="d-flex">
        <div class="question-label pt-2 pl-0 pr-0 pb-2 quicksand-bold-label">
          {{ question }}
        </div>
        <div class="reset-button ml-auto">
          <button class="text-white text-capitalize quicksand-bold-label reset" (click)="resetAssistantResponse()">
            <nb-icon icon="sync-outline" class="mr-1"></nb-icon> Reset
          </button>
        </div>
      </div>

      <hr />

      <div class="row answer-content">
        <div class="col-md-12 text-center" *ngIf="!answer && !question">
          <img src="/assets/images/favicon1.png" alt="logo" height="150" width="150" loading="lazy" />
          <h6 class="quicksand-bold-label mt-2">
            {{
              localStorageUser?.user?.role_id !== 19
                ? "Have a question? Just ask, I'm here to help!"
                : 'Click on any query to see the AI generated response'
            }}
          </h6>
        </div>

        <div class="row m-0 w-100" *ngIf="question && answer">
          <div class="col-md-1">
            <img src="/assets/images/favicon1.png" alt="logo" height="52" width="52" class="logo-img" loading="lazy" />
          </div>

          <div
            class="col-md-11 quicksand-normal-label question-content"
            style="white-space: pre-wrap"
            [innerHTML]="answer"
          ></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- super admin delete assitant records dialog -->
<ng-template #dialogDelete>
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="text-center">
      <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
      <br />

      <label class="label-delete-lesson-plan mt-2 quicksand-bold-label">Delete Question</label>
      <br />
      <label class="label-delete-lesson-plan quicksand-bold-label">Are you sure want to delete this question ?</label>
    </div>
    <div class="d-flex">
      <button
        nbButton
        class="delete-lesson-plan bg-white bg-white-color m-2 w-100 quicksand-bold-label text-capitalize"
        (click)="dialogRef.close()"
      >
        Cancel
      </button>
      <button
        nbButton
        color="warn"
        class="delete-lesson-plan delete m-2 w-100 quicksand-bold-label text-capitalize"
        (click)="deleteQuestion()"
      >
        Delete
      </button>
    </div>
  </div>
</ng-template>
